import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) {}

  /***********************login************************** */

  authenticateUser(data) {
    return this.http.post(
      '/cphc-auth/oauth/token',
      'grant_type=password&password=' +
        data.password +
        '&username=' +
        data.username +
        '&kaptcha=' +
        data.kaptcha +
        '&source_type=' +
        data.source_type,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', 'Basic TkNEQnJvd3NlcjpTZWN1cmVOQ0Q=')
          .set('txnUser', data.username)
      }
    );
  }

  logout() {
    return this.http.post('/cphm/oauth/token/revokeById/' + sessionStorage.getItem('jti'), '', {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  resetPassword(data) {
    return this.http.post('/cphm/PasswordMgmt/resetPasswordWithOtp', data);
  }

  generateOTP(reqObj, kaptcha) {
    return this.http.post('/cphc-auth/PasswordMgmt/getOTPForResetPwd', reqObj, {
      headers: new HttpHeaders().set('kaptcha', kaptcha),
    });
  }

  syncData() {
    return this.http.get('/cphm/sync/command?action=start');
  }
}
